module.exports = __webpack_public_path__ + "static/admin-21129a495a59698d61ee0b66f19bc9af.jpg";